import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import LoadingPage from './loading.vue';

export const loadingPage = () => {
    const container = document.querySelector('body>div') as Element;

    // clear the page first
    while (container.firstChild) container.removeChild(container.firstChild);

    // then add a div to place the loading page in so that we don't
    // remove the selector element from the DOM completely
    const newMountPoint = document.createElement('div');
    container.appendChild(newMountPoint);

    // initialise vuetify
    Vue.use(Vuetify);

    let vuetify = new Vuetify({
        theme: { dark: true }
    });

    return new Vue({
        vuetify,
        render: h => h(LoadingPage)
    }).$mount(newMountPoint);
};
